import {ReactElement} from "react";
import * as React from "react";

import {useEffect, useMemo, useState} from "react";
import SVGCross from "../../svg_icons/SVGCross";

import "./Drawer_style.css";

const DEFAULT_WIDTH = 400;
const DEFAULT_HEIGHT = 240;

export type DrawerProps = Readonly<{
    alignment: "top" | "right" | "bottom" | "left",
    className?: string,
    isVisible: boolean,
    width?: number | null,
    height?: number | null,
    onClose?: () => void,
    showCloseButton?: boolean,
    renderContainer?: boolean,
}>

type Props = Readonly<DrawerProps &{
    children: React.ReactNode,
}>

export default function Drawer(
    {className, alignment = "left", isVisible, width, height, onClose, showCloseButton = true, renderContainer = true, children}: Props,
): ReactElement {
    const [windowSize, setWindowSize] = useState({width: window.innerWidth, height: window.innerHeight});

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            })
        }

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const {actualWidth, actualHeight} = useMemo(() => {
        const actualWidth = alignment === "left" || alignment === "right" ? (width ?? DEFAULT_WIDTH) : windowSize.width;
        const actualHeight = alignment === "top" || alignment === "bottom" ? (height ?? DEFAULT_HEIGHT) : windowSize.height;

        return {actualWidth, actualHeight}
    }, [alignment, height, width, windowSize.height, windowSize.width]);

    const {top, left} = useMemo(() => {
        const top = alignment === "top" || alignment === "right" || alignment === "left" ? 0 : windowSize.height - actualHeight;
        const left = alignment === "top" || alignment === "bottom" || alignment === "left" ? 0 : windowSize.width - actualWidth;

        return {top, left};
    }, [actualHeight, actualWidth, alignment, windowSize.height, windowSize.width]);
    
    return <>
        {isVisible === true && (
            <div 
                className={`drawer-top-container${className == null ? "" : ` ${className}`}${renderContainer ? "" : " transparent-container"} ${alignment === "top" ? 'drawer-top' : alignment === "right" ? 'drawer-right' : alignment === "bottom" ? 'drawer-bottom' : 'drawer-left'}`} 
                style={{top: `${top}px`, left: `${left}px`, width: `${actualWidth}px`, height: `${actualHeight}px`}}>
                    {showCloseButton === true ? (
                        <div
                            className="flex-row flex-end"
                            style={{ flex: 0, padding: 8 }}
                        >
                            <div onClick={onClose}>
                                <SVGCross className="x-button" />
                            </div>
                        </div>
                    ) : null}
                    <div className="drawer-content-container">
                        {children}
                    </div>
            </div>)}
    </>;
}